import { render, staticRenderFns } from "./directedInquiry.vue?vue&type=template&id=b3c77fb6&scoped=true"
import script from "./directedInquiry.vue?vue&type=script&lang=js"
export * from "./directedInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c77fb6",
  null
  
)

export default component.exports